<template>
    <div class="row">
        <div class="col-xs-12">
            <combined
                api_route="/ajax/statistics/sources/detailed"
                title="Kombiniran pregled podatkov"/>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12">
            <!-- Sources -->
            <chart
                :columns="['vir', 'število']"
                api-url="/ajax/statistics/sources"
                title="Število uvoženih kontaktov glede na vir (brez bouncanih)"
                style-class="box-success"/>

            <!-- Emails -->
            <chart
                :columns="['e-poštni ponudnik', 'število']"
                api-url="/ajax/statistics/emails"
                title="E-poštni naslovi glede na ponudnike (brez bouncanih)"
                style-class="box-success"/>

            <!-- Regions -->
            <chart
                :columns="['regija', 'število']"
                :unknown-switch="true"
                api-url="/ajax/statistics/regions"
                title="Regije"
                style-class="box-danger"/>
            <!-- Municipalities -->
            <chart
                :columns="['občina', 'število']"
                :unknown-switch="true"
                api-url="/ajax/statistics/municipalities"
                title="Občine"
                style-class="box-success"/>

            <!-- Sex -->
            <chart
                :columns="['spol', 'število']"
                :unknown-switch="true"
                api-url="/ajax/statistics/sex"
                title="Spol"
                style-class="box-success"/>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12">
            <!-- Bounced Emails -->
            <chart
                :columns="['bounced', 'število']"
                api-url="/ajax/statistics/bounced"
                title="E-poštni naslovi glede na bounce rate"
                style-class="box-danger"/>

            <!-- Phones -->
            <chart
                :columns="['tip', 'število']"
                api-url="/ajax/statistics/phones"
                title="Telefonske številke"
                style-class="box-warning"/>

            <!-- Phone countries -->
            <chart
                :columns="['država', 'število']"
                api-url="/ajax/statistics/phones/countries"
                title="Telefonske številke po državah"
                style-class="box-info"/>

            <!-- Post offices -->
            <chart
                :columns="['pošta', 'število']"
                :unknown-switch="true"
                api-url="/ajax/statistics/posts"
                title="Pošte"
                style-class="box-default"/>

            <!-- Age -->
            <chart
                :columns="['starost', 'število']"
                :unknown-switch="true"
                :max-table-rows="12"
                api-url="/ajax/statistics/age"
                title="Starost"
                style-class="box-success"/>
        </div>
    </div>
</template>

<script>
import Chart    from './Chart';
import Combined from './Combined';

export default {
    name: 'Statistics',

    components: {
        Chart,
        Combined
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Statistics/Statistics.vue